import {EBreakpoint} from '@/common/scripts/constants';
import {gsap} from 'gsap';

const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="2" height="210" viewBox="0 0 2 210" fill="none">
  <path d="M2 210H0V208H2V210Z" fill="#0082FF"/>
  <path d="M2 206H0V204H2V206Z" fill="url(#paint0_linear_4454_10796)"/>
  <path d="M2 202H0V200H2V202Z" fill="url(#paint1_linear_4454_10796)"/>
  <path d="M2 198H0V196H2V198Z" fill="url(#paint2_linear_4454_10796)"/>
  <path d="M2 194H0V192H2V194Z" fill="url(#paint3_linear_4454_10796)"/>
  <path d="M2 190H0V188H2V190Z" fill="url(#paint4_linear_4454_10796)"/>
  <path d="M2 186H0V184H2V186Z" fill="url(#paint5_linear_4454_10796)"/>
  <path d="M2 182H0V180H2V182Z" fill="url(#paint6_linear_4454_10796)"/>
  <path d="M2 178H0V176H2V178Z" fill="url(#paint7_linear_4454_10796)"/>
  <path d="M2 174H0V172H2V174Z" fill="url(#paint8_linear_4454_10796)"/>
  <path d="M2 170H0V168H2V170Z" fill="url(#paint9_linear_4454_10796)"/>
  <path d="M2 166H0V164H2V166Z" fill="url(#paint10_linear_4454_10796)"/>
  <path d="M2 162H0V160H2V162Z" fill="url(#paint11_linear_4454_10796)"/>
  <path d="M2 158H0V156H2V158Z" fill="url(#paint12_linear_4454_10796)"/>
  <path d="M2 154H0V152H2V154Z" fill="url(#paint13_linear_4454_10796)"/>
  <path d="M2 150H0V148H2V150Z" fill="url(#paint14_linear_4454_10796)"/>
  <path d="M2 146H0V144H2V146Z" fill="url(#paint15_linear_4454_10796)"/>
  <path d="M2 142H0V140H2V142Z" fill="url(#paint16_linear_4454_10796)"/>
  <path d="M2 138H0V136H2V138Z" fill="url(#paint17_linear_4454_10796)"/>
  <path d="M2 134H0V132H2V134Z" fill="url(#paint18_linear_4454_10796)"/>
  <path d="M2 130H0V128H2V130Z" fill="url(#paint19_linear_4454_10796)"/>
  <path d="M2 126H0V124H2V126Z" fill="url(#paint20_linear_4454_10796)"/>
  <path d="M2 122H0V120H2V122Z" fill="url(#paint21_linear_4454_10796)"/>
  <path d="M2 118H0V116H2V118Z" fill="url(#paint22_linear_4454_10796)"/>
  <path d="M2 114H0V112H2V114Z" fill="url(#paint23_linear_4454_10796)"/>
  <path d="M2 110H0V108H2V110Z" fill="url(#paint24_linear_4454_10796)"/>
  <path d="M2 106H0V104H2V106Z" fill="url(#paint25_linear_4454_10796)"/>
  <path d="M2 102H0V100H2V102Z" fill="url(#paint26_linear_4454_10796)"/>
  <path d="M2 98H0V96H2V98Z" fill="url(#paint27_linear_4454_10796)"/>
  <path d="M2 94H0V92H2V94Z" fill="url(#paint28_linear_4454_10796)"/>
  <path d="M2 90H0V88H2V90Z" fill="url(#paint29_linear_4454_10796)"/>
  <path d="M2 86H0V84H2V86Z" fill="url(#paint30_linear_4454_10796)"/>
  <path d="M2 82H0V80H2V82Z" fill="url(#paint31_linear_4454_10796)"/>
  <path d="M2 78H0V76H2V78Z" fill="url(#paint32_linear_4454_10796)"/>
  <path d="M2 74H0V72H2V74Z" fill="url(#paint33_linear_4454_10796)"/>
  <path d="M2 70H0V68H2V70Z" fill="url(#paint34_linear_4454_10796)"/>
  <path d="M2 66H0V64H2V66Z" fill="url(#paint35_linear_4454_10796)"/>
  <path d="M2 62H0V60H2V62Z" fill="url(#paint36_linear_4454_10796)"/>
  <path d="M2 58H0V56H2V58Z" fill="url(#paint37_linear_4454_10796)"/>
  <path d="M2 54H0V52H2V54Z" fill="url(#paint38_linear_4454_10796)"/>
  <path d="M2 50H0V48H2V50Z" fill="url(#paint39_linear_4454_10796)"/>
  <path d="M2 46H0V44H2V46Z" fill="url(#paint40_linear_4454_10796)"/>
  <path d="M2 42H0V40H2V42Z" fill="url(#paint41_linear_4454_10796)"/>
  <path d="M2 38H0V36H2V38Z" fill="url(#paint42_linear_4454_10796)"/>
  <path d="M2 34H0V32H2V34Z" fill="url(#paint43_linear_4454_10796)"/>
  <path d="M2 30H0V28H2V30Z" fill="url(#paint44_linear_4454_10796)"/>
  <path d="M2 26H0V24H2V26Z" fill="url(#paint45_linear_4454_10796)"/>
  <path d="M2 22H0V20H2V22Z" fill="url(#paint46_linear_4454_10796)"/>
  <path d="M2 18H0V16H2V18Z" fill="url(#paint47_linear_4454_10796)"/>
  <path d="M2 14H0V12H2V14Z" fill="url(#paint48_linear_4454_10796)"/>
  <path d="M2 10H0V8H2V10Z" fill="url(#paint49_linear_4454_10796)"/>
  <path d="M2 6H0V4H2V6Z" fill="url(#paint50_linear_4454_10796)"/>
  <path d="M2 2H0V0H2V2Z" fill="url(#paint51_linear_4454_10796)"/>
  <defs>
    <linearGradient id="paint0_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint1_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint2_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint3_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint4_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint5_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint6_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint7_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint8_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint9_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint10_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint11_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint12_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint13_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint14_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint15_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint16_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint17_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint18_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint19_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint20_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint21_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint22_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint23_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint24_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint25_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint26_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint27_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint28_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint29_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint30_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint31_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint32_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint33_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint34_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint35_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint36_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint37_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint38_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint39_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint40_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint41_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint42_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint43_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint44_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint45_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint46_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint47_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint48_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint49_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint50_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
    <linearGradient id="paint51_linear_4454_10796" x1="1" y1="0" x2="1" y2="210" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0074E4" stop-opacity="0"/>
      <stop offset="1" stop-color="#0074E4" stop-opacity="0.7"/>
    </linearGradient>
  </defs>
</svg>`;

const RAIL_CONFIGS = [{
    duration: 5.0,
    delay   : 0.5
}, {
    duration: 3.2,
    delay   : 1.0
}, {
    duration: 5.0,
    delay   : 2.0
}, {
    duration: 3.4,
    delay   : 3.0
}, {
    duration: 4.8,
    delay   : 4.0
}, {
    duration: 7.0,
    delay   : 6.0
}] as const;

const PATTERN = [1, 3, 0, 5, 4, 0, 2, 1, 5, 1, 4, 2, 0, 1, 3, 5, 0, 2, 3, 4, 2, 0, 5, 0, 3, 0];

class RainAnimation {
    private container!: HTMLElement;

    constructor() {
        this.handleResize = this.handleResize.bind(this);
    }

    public init(container: HTMLElement): void {
        this.container = container;

        this.build();
        window.addEventListener('resize', this.handleResize);
    }

    private build(): void {
        const railCount = this.getRailCount();

        for (let i = 0; i < railCount; i++) {
            const rail = this.createRail();

            this.container.appendChild(rail);

            const drop = rail.querySelector('.rain__drop') as HTMLElement | null;

            if (drop) {
                this.animateDrop(drop, i);
            }
        }
    }

    private createRail(): HTMLElement {
        const rail = document.createElement('div');

        rail.className = 'rain__rail';

        const minTop = -20;
        const maxTop = 60;
        const top = minTop + (Math.random() * (maxTop - minTop));

        rail.style.transform = `translateY(${top}%)`;
        const drop = this.createDrop();

        rail.appendChild(drop);

        return rail;
    }

    private createDrop(): HTMLElement {
        const drop = document.createElement('div');

        drop.className = 'rain__drop';
        drop.innerHTML = svg;

        return drop;
    }

    private animateDrop(drop: HTMLElement, railIndex: number): void {
        const patternIndex = PATTERN?.[railIndex % PATTERN.length] ?? 0;
        const configIndex = patternIndex % RAIL_CONFIGS.length;
        const config = RAIL_CONFIGS?.[configIndex] || RAIL_CONFIGS[0];
        const duration = config.duration || 1;
        const delay = config.delay || 1;
        const rail = drop.parentElement;
        const railHeight = rail?.clientHeight ?? 766;
        const endY = railHeight + 60;

        gsap.fromTo(drop,
            {
                y      : -60,
                opacity: 0
            },
            {
                y        : endY,
                duration,
                delay,
                ease     : 'none',
                opacity  : 0,
                keyframes: {
                    opacity: [0, 0.7, 0]
                },
                repeat     : -1,
                repeatDelay: delay
            });
    }

    private getRailCount(): number {
        const w = window.innerWidth;

        if (w < EBreakpoint.TABLET_PORTRAIT) {
            return 5;
        }
        if (w < EBreakpoint.DESKTOP) {
            return 10;
        }

        return 26;
    }

    private handleResize(): void {
        this.build();
    }
}

export default RainAnimation;
